import { InfoIcon } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from 'components/Tooltip';
import { Typography } from 'components/typography';
import { IntegrationCore } from 'types/Integration';
import { getDrumkitContainer } from 'utils/getDrumkitContainer';

import { getGranularEquipmentTooltip } from './types';

interface EquipmentInfoTooltipProps {
  quotingIntegrations?: IntegrationCore[];
  tmsIntegrations?: IntegrationCore[];
}

/**
 * Info icon + tooltip shown next to the granular Equipment dropdown label. Explains that the
 * granular equipment type is auto-mapped to the generic transport type the user's quoting
 * engines support, naming their actual enabled quoting engines and TMS.
 */
export const EquipmentInfoTooltip = ({
  quotingIntegrations,
  tmsIntegrations,
}: EquipmentInfoTooltipProps) => (
  <Tooltip delayDuration={10}>
    <TooltipTrigger type='button' className='inline-flex items-center'>
      <InfoIcon className='h-3.5 w-3.5 cursor-help text-neutral-500' />
    </TooltipTrigger>
    <TooltipPortal container={getDrumkitContainer()}>
      <TooltipContent className='max-w-72 whitespace-pre-wrap'>
        <Typography variant='body-xs'>
          {getGranularEquipmentTooltip(quotingIntegrations, tmsIntegrations)}
        </Typography>
      </TooltipContent>
    </TooltipPortal>
  </Tooltip>
);
